'use strict';

export default class Modal {
    constructor() {

        $('.closemodal').on("click", function (e) {
            e.preventDefault();
            $(this).parents('.confirm-message').hide();
        });
    }
}